var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndToEndSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7379 10.5427L23.5958 0L20.2508 3.23875L24.763 7.56164C24.354 7.54318 23.945 7.53392 23.536 7.53392L23.5306 7.53399C16.9689 7.61515 11.3973 9.84123 6.84167 14.2128C2.28535 18.585 0 23.897 0 30.1242C0 32.9697 0.494281 35.6486 1.48581 38.1573C2.47581 40.662 3.89634 42.9323 5.74508 44.9663L6.04544 45.2968L9.78604 41.7574L9.48723 41.4433C8.0111 39.8913 6.92568 38.1085 6.22869 36.0912C5.52556 34.0562 5.17649 32.0678 5.17649 30.1242C5.17649 25.2932 6.94151 21.1729 10.4872 17.7399C14.0314 14.3084 18.3733 12.5525 23.5393 12.4736C23.8628 12.4737 24.336 12.493 24.964 12.5326C25.216 12.5485 25.4533 12.5676 25.676 12.5897L20.1854 17.7849L23.5959 21.0854L34.7379 10.5427Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2621 44.4574L31.4042 55.0002L34.7492 51.7614L30.237 47.4385C30.646 47.457 31.055 47.4662 31.464 47.4662L31.4694 47.4662C38.0311 47.385 43.6027 45.1589 48.1583 40.7874C52.7146 36.4151 55 31.1032 55 24.876C55 22.0305 54.5057 19.3515 53.5142 16.8429C52.5242 14.3381 51.1037 12.0679 49.2549 10.0338L48.9546 9.70337L45.214 13.2428L45.5128 13.5569C46.9889 15.1088 48.0743 16.8916 48.7713 18.9089C49.4744 20.944 49.8235 22.9324 49.8235 24.876C49.8235 29.707 48.0585 33.8273 44.5128 37.2603C40.9686 40.6918 36.6267 42.4476 31.4607 42.5266C31.1372 42.5264 30.664 42.5072 30.036 42.4675C29.784 42.4516 29.5467 42.4326 29.324 42.4105L34.8146 37.2152L31.4041 33.9148L20.2621 44.4574Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndToEndSolutions);
export default __webpack_public_path__ + "static/media/end-to-end-solutions.9b35b359a0de94ff45ca68216a168bd3.svg";
export { ForwardRef as ReactComponent };